/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { useNotification } from 'src/contexts/notification.context'
import { getNotifications } from 'src/services/api.service'

export const Notifications = () => {
  const [items, setItems] = useState([])
  const { wrapCallback } = useNotification()

  useEffect(() => {
    wrapCallback(async () => {
      const response = await getNotifications()
      setItems(response.data?.items)
    })
  }, [])

  console.log(items);

  return (
    <>
      <h2 className="sectionHb-title">Notifications</h2>

      <div className="sectionHb-block review invites">
        <div className="sectionHb-block__wrap">
          <div className="notification-block">
            <h3 className="notification-title">New</h3>
            <div className="notification-list">
              <div className="notification-item">
                <div className="notification-user">
                  {/* <img src="img/options-user.jpg" alt="" /> */}
                  <i className="active" />
                </div>
                <div className="notification-item__info">
                  <p>
                    <b>James Bond</b> Added a new lesson{' '}
                    <a href="#">lesson 12345 and lesson</a> to his pageto his
                    pageto his pageto his page...
                  </p>
                  <span className="notification-date">5h ago</span>
                </div>
                <a href="#" className="hb-ico trash-ico" />
              </div>
              <div className="notification-item">
                <div className="notification-user">?</div>
                <div className="notification-item__info">
                  <p>
                    <b>James Bond</b> Added a new lesson{' '}
                    <a href="#">lesson 12345 and lesson</a> to his pageto his
                    pageto his pageto his page...
                  </p>
                  <span className="notification-date">5h ago</span>
                </div>
                <a href="#" className="hb-ico trash-ico" />
              </div>
            </div>
          </div>

          <div className="notification-block">
            <h3 className="notification-title">Earlier</h3>
            <div className="notification-list">
              <div className="notification-item">
                <div className="notification-user">
                  {/* <img src="img/options-user.jpg" alt="" /> */}
                  <i className="active" />
                </div>
                <div className="notification-item__info">
                  <p>
                    <b>James Bond</b> Added a new lesson{' '}
                    <a href="#">lesson 12345 and lesson</a> to his pageto his
                    pageto his pageto his page...
                  </p>
                  <span className="notification-date">5h ago</span>
                </div>
                <a href="#" className="hb-ico trash-ico" />
              </div>
              <div className="notification-item">
                <div className="notification-user">
                  {/* <img src="img/options-user.jpg" alt="" /> */}
                </div>
                <div className="notification-item__info">
                  <p>
                    <b>James Bond</b> Added a new lesson{' '}
                    <a href="#">lesson 12345 and lesson</a> to his pageto his
                    pageto his pageto his page...
                  </p>
                  <span className="notification-date">5h ago</span>
                </div>
                <a href="#" className="hb-ico trash-ico" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
